module.exports = __webpack_public_path__ + "img/why-icon-1.dbee458b.svg";